"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GpsTrackingRev = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var GpsTrackingRev = function GpsTrackingRev(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 31 30"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_69272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 24.75C9.86764 24.75 10.875 23.7426 10.875 22.5C10.875 21.2574 9.86764 20.25 8.625 20.25C7.38236 20.25 6.375 21.2574 6.375 22.5C6.375 23.7426 7.38236 24.75 8.625 24.75Z",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 9.75C23.3676 9.75 24.375 8.74264 24.375 7.5C24.375 6.25736 23.3676 5.25 22.125 5.25C20.8824 5.25 19.875 6.25736 19.875 7.5C19.875 8.74264 20.8824 9.75 22.125 9.75Z",
    stroke: "#DF434D",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.575 22.5H20.525C21.5461 22.5 22.5253 22.1049 23.2474 21.4017C23.9694 20.6984 24.375 19.7446 24.375 18.75C24.375 17.7554 23.9694 16.8016 23.2474 16.0983C22.5253 15.3951 21.5461 15 20.525 15H11.725C10.7039 15 9.72465 14.6049 9.00264 13.9016C8.28062 13.1984 7.875 12.2446 7.875 11.25C7.875 10.2554 8.28062 9.30161 9.00264 8.59835C9.72465 7.89509 10.7039 7.5 11.725 7.5H15.575",
    stroke: "#2EA8E5",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1352_69272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48942 11C5.68963 11 3.375 13.2388 3.375 16.0086C3.375 17.4044 3.88201 18.7002 4.71812 19.7985C5.63195 21.01 6.76802 22.0656 8.05406 22.8941C8.37527 23.1001 8.6394 23.0856 8.93206 22.8941C10.2108 22.0656 11.3469 21.01 12.2686 19.7985C13.1041 18.7002 13.6117 17.4044 13.6117 16.0086C13.6117 13.2388 11.2971 11 8.48942 11Z",
    fill: "#DF434D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1352_69272)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1352_69272",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.45149 17.8217C7.52309 17.8217 6.76591 17.0919 6.76591 16.164C6.76591 15.2434 7.52309 14.478 8.45149 14.478C9.3805 14.478 10.145 15.2434 10.145 16.164C10.145 17.0919 9.3805 17.8217 8.45149 17.8217"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.45149 17.8217C7.52309 17.8217 6.76591 17.0919 6.76591 16.164C6.76591 15.2434 7.52309 14.478 8.45149 14.478C9.3805 14.478 10.145 15.2434 10.145 16.164C10.145 17.0919 9.3805 17.8217 8.45149 17.8217",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45149 17.6217C7.62921 17.6217 6.96591 16.9772 6.96591 16.164H6.56591C6.56591 17.2067 7.41697 18.0217 8.45149 18.0217V17.6217ZM6.96591 16.164C6.96591 15.3531 7.63421 14.678 8.45149 14.678V14.278C7.41197 14.278 6.56591 15.1336 6.56591 16.164H6.96591ZM8.45149 14.678C9.27056 14.678 9.94496 15.3543 9.94496 16.164H10.345C10.345 15.1324 9.49045 14.278 8.45149 14.278V14.678ZM9.94496 16.164C9.94496 16.976 9.27557 17.6217 8.45149 17.6217V18.0217C9.48544 18.0217 10.345 17.2078 10.345 16.164H9.94496Z",
    fill: "url(#paint0_linear_1352_69272)",
    fillOpacity: "0.5",
    mask: "url(#path-5-inside-1_1352_69272)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1352_69272",
    x: "-20.625",
    y: "-13",
    width: "58.2367",
    height: "60.0432",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: "12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1352_69272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1352_69272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1352_69272",
    x: "-8.23409",
    y: "-0.521973",
    width: "33.3791",
    height: "33.3438",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: "7.5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1352_69272"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: "5",
    dy: "5"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1352_69272",
    result: "effect2_dropShadow_1352_69272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1352_69272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_69272",
    x1: "7.12991",
    y1: "15.5997",
    x2: "9.99919",
    y2: "15.6157",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_69272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "30",
    height: "30",
    fill: "white",
    transform: "translate(0.375)"
  }))));
};
exports.GpsTrackingRev = GpsTrackingRev;